import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { GreenroomState } from "../../stores/types/types";

const Container = styled.div`
    position: relative;
    height: 64px;
    width: 64px;
    align-self: center;
`;

const CircleContainer = styled.g`
    fill: none;
    stroke: none;
`;

const CircleSVG = styled.svg`
    transform: scaleX(-1);
`;

const TimerLabel = styled.span`
    /* Size should match the parent container */
    width: 64px;
    height: 64px;
  
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
`;

const CirclePath = styled.path<{ $usePixel?: boolean }>`
    stroke-width: 5px;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    stroke: ${({ $usePixel }) => ($usePixel ? 'var(--product-acc-400)' : 'url(#gradient)')};
`;

const FULL_DASH_ARRAY = 283;

interface Props {
    seconds: number;
    startTime: number;
}

export default function CountdownTimer(props: Props) {
	const { seconds, startTime } = props;
	const { use_pixel: usePixel } = useSelector((state: GreenroomState) => state.SettingsReducer.featureFlags);

    const elapsed = (Date.now() - startTime) / 1000;
    const left = Math.max(Math.floor(seconds - elapsed), 0);
    const timeFraction = (left / seconds) * FULL_DASH_ARRAY;
	const [timeLeft, setTimeLeft] = useState(left);
    const [circleDashArray, setCircleDashArray] = useState(timeFraction.toFixed(0) + ' 283');

	let timerInterval: NodeJS.Timeout;

	const updateTimer = () => {
		timerInterval = setInterval(() => {
            const elapsed = (Date.now() - startTime) / 1000;
            let timeLeft = Math.max(Math.floor(seconds - elapsed), 0);;
            setTimeLeft(timeLeft);

            const timeFraction = (timeLeft / seconds) * FULL_DASH_ARRAY;
            setCircleDashArray(timeFraction.toFixed(0) + ' 283');

            if (timeLeft == 0) {
                clearInterval(timerInterval);
            }
		}, 1000);
	};

	useEffect(() => {
		updateTimer();
		return () => { clearInterval(timerInterval); }
	}, []);

	return (
        <Container>
            <CircleSVG viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#FFF85C" />
                        <stop offset="100%" stopColor="#FF6AE6" />
                    </linearGradient>
                </defs>
                <CircleContainer>
                    <CirclePath
                        id="base-timer-path-remaining"
                        $usePixel={usePixel}
                        strokeDasharray={circleDashArray}
                        d="
                        M 50, 50
                        m -45, 0
                        a 45,45 0 1,0 90,0
                        a 45,45 0 1,0 -90,0
                        "
                    ></CirclePath>
                </CircleContainer>
            </CircleSVG>
            <TimerLabel>{timeLeft}</TimerLabel>
        </Container>
	);
}
